export default {
  profileCreated: '#33BF4A',
  existing: '#6C80EA',
  returned: '#858585',
  opened: '#E7BD52',
  notSent: '#000',
  notOpened: '#D71B1B',
  invited: '#E7BD52',
};
